import React from 'react';
import { checkboxPropTypes } from '@App/common/components/Checkbox/CheckboxPropTypes';
import CheckboxCommon from '@App/common/components/Checkbox/Checkbox';
import * as styles from './Checkbox.module.scss';
const Checkbox = props => /*#__PURE__*/React.createElement(CheckboxCommon, Object.assign({}, props, {
  classname: `${styles.root} ${props.error ? styles.rootError : ''}`
}));
export default Checkbox;